import React, { useState, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import LogoImg from "../assets/images/newageislam-logo.png";

// import SideBar from "./sidebarInnerPage.component";

const HeaderSection = ({ writers, history, location }) => {
  const [search, setSearch] = new useState("");
  const [showSideBarHeader, setShowSideBarHeader] = new useState(false);
  const [showSubMenuHeader, setShowSubMenuHeader] = new useState(false);
  const [date, setDate] = new useState(new Date());

  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      setDate(new Date());
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [date]);

  const getSearch = () => {
    if(search.trim() ===""){
      return;
    }
    history.push({ pathname: "/search", search: `?searchKey=${search}` });
  };
  const onBarClick = () => {
    setShowSideBarHeader(!showSideBarHeader);
    if (showSubMenuHeader) {
      setShowSubMenuHeader(!showSubMenuHeader);
    }
  };
  const onIconClick = (e) => {
    e.stopPropagation();
    setShowSubMenuHeader(!showSubMenuHeader);
  };

  return (
    <header className="mainHeader mb-3">
      <section className="headerTop py-2">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-5 col-md-4 col-lg-4">
              <div className="myBrand">
                <a href="/" className="d-block">
                  <img
                    src={LogoImg}
                    alt="New Age Islam"
                    className="img-fluid"
                    width="400"
                    height="93"
                  />
                </a>
              </div>
            </div>
            <div className="col-12 col-sm-7 col-md-8 col-lg-8 d-none d-sm-block">
              <div className="headerTopRight text-right">
                <ul className="list-inline m-0 p-0">
                  <li className="list-inline-item">
                    <a
                      href="https://www.facebook.com/NewAgeIslam/"
                      title="facebook"
                    >
                      <i className="fa fa-facebook-square"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="http://twitter.com/NewAgeIslam" title="twitter">
                      <i className="fa fa-twitter-square"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="mailto:editor@NewAgeIslam.com" title="Email">
                      <i className="fa fa-envelope-o"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="http://linkedin.com" title="Linkedin">
                      <i className="fa fa-linkedin-square"></i>
                    </a>
                  </li>
                </ul>
                <div className="dateHeader">
                  {new Date().toDateString("en-US")},{" "}
                  {date.toLocaleTimeString("en-US")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="headerMenu">
        <div className="container">
          <div className="row">
            <div
              className={
                "col-12 col-sm-12 col-md-12 col-lg-11 menuLeft " +
                (showSideBarHeader ? "show" : "hide")
              }
            >
              <div
                className="mobileIcon d-block d-lg-none"
                onClick={onBarClick}
              >
                <i className="fa fa-bars"></i>
              </div>
              <div className="mobileName d-block d-lg-none py-3 mb-3 border-bottom">
                <a className="d-block" href="/">
                  <img
                    src={LogoImg}
                    alt="New Age Islam"
                    className="img-fluid"
                    width="270"
                    height="69"
                  />
                </a>
              </div>
              <ul
                className="list-inline m-0 headerMenuList"
                onClick={onBarClick}
              >
                <li className="list-inline-item">
                  <Link to="/" title="Home">
                    Home{" "}
                  </Link>
                </li>
                <li className="list-inline-item">
                  <a
                    href="#"
                    title="Authors"
                    onClick={(e) => {
                      e.preventDefault();
                      onIconClick(e);
                    }}
                  >
                    Authors
                  </a>
                  <i
                    className={
                      "fa fa-angle-down position-absolute " +
                      (showSubMenuHeader ? "submenushow" : "submenuhide")
                    }
                    onClick={onIconClick}
                  ></i>
                  <ul className="list-unstyled m-0 subMenu position-absolute">
                    {writers.map(({ writerId, writerName }) => {
                      return (
                        <li key={writerId} onClick={onBarClick}>
                          <Link
                            title="Authors"
                            to={{
                              pathname: `/articles/${writerName}/${writerId}`,
                            }}
                          >
                            {" "}
                            {writerName}{" "}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </li>
                <li className="list-inline-item">
                  <Link to="/about" title="About us">
                    About us
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/bestArticles" title="Archives">
                    Archives
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="/latestVideos"
                    rel="noopener noreferrer"
                    title="New Age Islam TV"
                  >
                    New Age Islam TV
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="/articles/sections/books-and-documents/36"
                    title="Books and Documents"
                  >
                    Books
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/donate" title="Donate">
                    Donate
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/advertise" title="Advertise">
                    Advertise
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/subscribe" title="Subscribe">
                    Subscribe
                  </Link>
                  {/* <a
                    href={`${
                      location.pathname === "/"
                        ? "#subscribeSection"
                        : "/#subscribeSection"
                      }`}
                    title="Subscribe"
                  >
                    Subscribe
                  </a> */}
                </li>
              </ul>
              {/* <div
                className={
                  "mobile-side-bar " + (showSideBarHeader ? "show" : "hide")
                }
              >
              </div> */}
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-1 searchRight">
              <div className="dexktopSearchWrap text-center">
                <div className="dexktopSearchIcon float-right position-relative">
                  <i className="fa fa-search" onClick={getSearch}></i>
                  {
                    <input
                      type="search"
                      name="search"
                      className="form-control rounded-0"
                      placeholder="Enter keywords"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="headerNewsHighlight py-3">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="headerNewsWrap border clearfix">
                <h3 className="text-uppercase position-relative m-0 text-white text-center py-2 pl-4 pr-5 float-left">
                  Latest News
                </h3>
                <ul className="list-inline m-0 py-2 px-3 float-left">
                  <marquee
                    behavior="scroll"
                    direction="left"
                    scrollamount="4"
                    truespeed="30"
                  >
                    <li className="list-inline-item">
                      <a href="/" title="">
                        Ea essent rationibus vituperatoribus!
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/" title="">
                        Ea essent rationibus vituperatoribus est!
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="/" title="">
                        Ea essent rationibus vituperatoribus!
                      </a>
                    </li>
                  </marquee>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </header>
  );
};

export default withRouter(HeaderSection);
